import { render } from "./BaseButton.vue?vue&type=template&id=28334db8&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=28334db8&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28334db8"]])

export default __exports__